import { withQuery } from './lib/withQuery'

export const getAudioSuggestionsUrl = (username: string, slug: string) =>
    withQuery('suggestions/audio', { username, slug })

export const getAuthorSuggestionsUrl = (username: string) =>
    withQuery('suggestions/author', { username })

export const getCollectionSuggestionsUrl = (username: string, slug: string) =>
    withQuery('suggestions/collection', { username, slug })
